import imageDe from '../images/de/uploader-caresens-1.png';
import imageEn from '../images/en/uploader-caresens-1.png';
import imageEs from '../images/es/uploader-caresens-1.png';
import imageFi from '../images/fi/uploader-caresens-1.png';
import imageFr from '../images/fr/uploader-caresens-1.png';
import imageIt from '../images/it/uploader-caresens-1.png';
import imageNo from '../images/no/uploader-caresens-1.png';
import imageSv from '../images/sv/uploader-caresens-1.png';

export const uploaderSelectDeviceImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
